
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/write-review",
      function () {
        return require("private-next-pages/write-review.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/write-review"])
      });
    }
  